import type { IconName } from '../design-system/Icon';

export const PRIMARY_NAVIGATION = [
  { label: 'Today', route: 'today', icon: 'today' },
  { label: 'Clients', route: 'clients', icon: 'clients', badge: '7' },
  { label: 'Stories', route: 'stories', icon: 'stories' },
  { label: 'Opportunities', route: 'opportunities', icon: 'opportunities', alert: '4' },
  { label: 'Influence Graph', route: 'influence-graph', icon: 'graph' },
  { label: 'Campaigns', route: 'campaigns', icon: 'campaigns' },
  { label: 'My PR Work', route: 'my-pr-work', icon: 'today' },
  { label: 'Fluxroom', route: 'fluxroom', icon: 'fluxroom' },
] as const satisfies ReadonlyArray<{ label: string; route: string; icon: IconName; badge?: string; alert?: string }>;

export const OPERATOR_NAVIGATION = [
  { label: 'Submit Press Release', route: 'submit', icon: 'stories' },
  { label: 'Track Engagement', route: 'track', icon: 'campaigns' },
  { label: 'Search Media Relationships', route: 'connect', icon: 'search' },
] as const satisfies ReadonlyArray<{ label: string; route: string; icon: IconName }>;

export const ADVANCED_NAVIGATION = [
  { label: 'Admin Overview', route: 'admin' },
  { label: 'Import Media', route: 'import-media' },
  { label: 'Workspace Settings', route: 'settings' },
  { label: 'Client Intelligence', route: 'clients' },
  { label: 'Story Intelligence', route: 'stories' },
  { label: 'Opportunities', route: 'opportunities' },
  { label: 'Outcome Entry', route: 'outcome-entry' },
  { label: 'Identity Review', route: 'identity-review' },
  { label: 'Research Inbox', route: 'research-inbox' },
  { label: 'Pitch Studio', route: 'pitch-studio' },
  { label: 'My PR Work', route: 'my-pr-work' },
] as const;

export type NavigationLabel = (typeof PRIMARY_NAVIGATION)[number]['label'] | (typeof OPERATOR_NAVIGATION)[number]['label'];
